import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { connect } from 'react-redux';
import {
  reduxForm,
  Field,
  SubmissionError,
  formValueSelector,
} from 'redux-form';
import { TextField, SelectField, AutoComplete } from 'redux-form-material-ui';
import { AutoComplete as MUIAutoComplete } from 'material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';

import { required } from '../../validators';
import { sendPushNotification } from '../../mutations';
import enhancer from '../enhancer';

const styles = {
  root: {
    padding: 10,
  },
};

const extractId = value => {
  if (value) {
    return parseInt(atob(value).split(':')[1], 10);
  }

  return null;
};

let PushNotification = class extends React.Component {
  submit = async values => {
    try {
      const { target } = values;
      let targetUser = null;

      if (target === 'tutor') {
        targetUser = extractId(values.tutor.value);
      } else if (target === 'student') {
        targetUser = extractId(values.student.value);
      }

      await sendPushNotification({
        input: {
          title: values.title,
          payload: values.payload,
          entityId: values.entityId,
          entityType: values.entityType,
          target,
          targetUser,
        },
      });
    } catch (ex) {
      throw new SubmissionError({ _error: ex });
    }
  };

  render() {
    const {
      handleSubmit,
      error,
      pristine,
      submitting,
      target,
      admin,
      relay,
    } = this.props;

    const tutorDataSource = admin.allTutors.edges.map(edge => {
      const { node } = edge;
      return {
        text: `${node.firstname} ${node.lastname} (${node.user.email})`,
        value: node.user.id,
      };
    });

    const studentDataSource = admin.allStudents.edges.map(edge => {
      const { node } = edge;
      return {
        text: `${node.firstname} ${node.lastname} (${node.user.email})`,
        value: node.user.id,
      };
    });

    return (
      <div style={styles.root}>
        <form onSubmit={handleSubmit(this.submit)}>
          <Field
            name="title"
            floatingLabelText="Title"
            component={TextField}
            validate={required}
          />
          <br />
          <Field
            name="payload"
            floatingLabelText="Payload"
            multiLine
            component={TextField}
          />
          <br />
          <Field
            name="target"
            floatingLabelText="Target"
            component={SelectField}
          >
            <MenuItem value="student" primaryText="Student" />
            <MenuItem value="tutor" primaryText="Tutor" />
            <MenuItem value="all_tutors" primaryText="All Tutors" />
            <MenuItem value="all_students" primaryText="All Students" />
          </Field>
          <br />
          {target === 'tutor' ? (
            <div>
              <Field
                name="tutor"
                fullWidth
                floatingLabelText="Tutor"
                component={AutoComplete}
                openOnFocus
                filter={MUIAutoComplete.fuzzyFilter}
                onUpdateInput={searchText => {
                  relay.setVariables({
                    searchTutor: searchText,
                  });
                }}
                dataSource={tutorDataSource}
                dataSourceConfig={{ text: 'text', value: 'value' }}
              />
              <br />
            </div>
          ) : null}
          {target === 'student' ? (
            <div>
              <Field
                name="student"
                fullWidth
                floatingLabelText="Student"
                component={AutoComplete}
                openOnFocus
                filter={MUIAutoComplete.fuzzyFilter}
                onUpdateInput={searchText => {
                  relay.setVariables({
                    searchStudent: searchText,
                  });
                }}
                dataSource={studentDataSource}
                dataSourceConfig={{ text: 'text', value: 'value' }}
              />
              <br />
            </div>
          ) : null}
          <Field
            name="entityId"
            floatingLabelText="Entity Id"
            component={TextField}
          />
          <br />
          <Field
            name="entityType"
            floatingLabelText="Entity Type"
            component={SelectField}
          >
            <MenuItem value="activity" primaryText="Activity" />
            <MenuItem value="job" primaryText="Class Booked" />
            <MenuItem value="job_offer" primaryText="Class Offer" />
            <MenuItem value="job_request" primaryText="Class Request" />
            <MenuItem value="other" primaryText="Other" />
          </Field>
          <br />
          {error && <strong>{error}</strong>}
          <RaisedButton
            disabled={submitting || pristine}
            label="Send"
            onClick={handleSubmit(this.submit)}
            primary
          />
        </form>
      </div>
    );
  }
};

PushNotification = reduxForm({
  initialValues: {
    target: 'student',
  },
  form: 'testingForm',
})(PushNotification);

const selector = formValueSelector('testingForm');
PushNotification = connect(state => ({
  target: selector(state, 'target'),
}))(PushNotification);

const query = graphql`
  query PushNotificationAdminQuery(
    $firstStudents: Int
    $firstTutors: Int
    $searchStudent: String
    $searchTutor: String
  ) {
    admin {
      ...PushNotification_admin
    }
  }
`;

export default enhancer(PushNotification, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(PushNotification, {
        admin: graphql`
          fragment PushNotification_admin on Admin {
            allStudents(first: $firstStudents, fuzzy: $searchStudent) {
              edges {
                node {
                  user {
                    id
                    email
                  }
                  firstname
                  lastname
                }
              }
            }
            allTutors(first: $firstTutors, fuzzy: $searchTutor) {
              edges {
                node {
                  user {
                    id
                    email
                  }
                  firstname
                  lastname
                }
              }
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/admin/PushNotification.js